import clsx from 'clsx'
import '../../styles/slp.css'

/**
 * SLP bottom status bar — left: event stream text rendered as
 * `Status > <event>`; right: `logged in as <role>`.
 *
 * Layout-neutral (no fixed positioning) so pages decide placement; pin with
 * e.g. `className="fixed inset-x-0 bottom-0"` when used as the page footer.
 */
export function StatusBar({
  event,
  role,
  className,
}: {
  /** Latest event line, e.g. "Connection established to voice talent 2". */
  event?: string
  /** Current user role, e.g. "studio" — renders "logged in as studio". */
  role?: string
  className?: string
}) {
  return (
    <footer
      data-testid="rt-status-bar"
      className={clsx(
        // v2.13: fixed 24px bar, 11px text
        'flex h-[24px] items-center justify-between gap-4 border-t border-[var(--slp-statusbar-border)]',
        'bg-[var(--slp-statusbar-bg)] px-3 text-[11px] text-[var(--slp-text)]',
        className,
      )}
    >
      <span data-testid="rt-status-bar-event" className="truncate">
        <span className="font-semibold">Status</span>
        <span className="mx-1 text-[var(--slp-text-dim)]">&gt;</span>
        {event ?? 'Ready'}
      </span>
      {role ? (
        <span data-testid="rt-status-bar-role" className="shrink-0 text-[var(--slp-text-dim)]">
          logged in as <span className="font-semibold text-[var(--slp-text)]">{role}</span>
        </span>
      ) : null}
    </footer>
  )
}
